
<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Ujian Klasikal">
            <common-training-header/>
        </a-page-header>

        <a-card type="inner" size="small">


            <a-table
                class="pcp-table"
                :dataSource="items.material_sessions"
                :loading="loading"
                rowKey="id"
                :pagination="false"
                bordered>

                <a-table-column key="title" title="Sesi Pelatihan" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <a-table-column key="inspirator" title="Inspirator" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <a-icon type="user" /> {{ record.inspirator.name }}<br/>
                        <a-tooltip>
                            <a-icon type="book" theme="twoTone" /> {{ record.material.name }}
                        </a-tooltip>
                    </template>
                </a-table-column>

                <a-table-column key="time_start" title="Jadwal Sesi" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <a-tooltip>
                            <template slot="title">
                            Sesi dimulai
                            </template>
                            <a-icon type="calendar" /> <strong> {{ moment(record.session_time_start).format('DD MMMM YYYY HH:mm:ss') }}</strong>
                        </a-tooltip>
                        <br />
                        s/d
                        <br />
                        <a-tooltip>
                            <template slot="title">
                            Sesi berakhir
                            </template>
                            <a-icon type="calendar" /> <strong> {{ moment(record.session_time_end).format('DD MMMM YYYY HH:mm:ss') }}</strong>
                        </a-tooltip>
                    </template>
                </a-table-column>

                <a-table-column key="exam" title="Jadwal Ujian" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <template v-if="record.exam_time_start != null">
                            <template v-if="record.actual_exam_time_end != null">
                                <a-tooltip>
                                    <template slot="title">
                                    Ujian dimulai
                                    </template>
                                    <a-icon type="calendar" />
                                    <strong> {{ moment(record.actual_exam_time_start).format('DD MMMM YYYY HH:mm:ss') }} </strong>
                                </a-tooltip>
                                <br />
                                s/d
                                <br />
                                <a-tooltip>
                                    <template slot="title">
                                    Ujian berakhir
                                    </template>
                                    <a-icon type="calendar" /><strong> {{ moment(record.actual_exam_time_end).format('DD MMMM YYYY HH:mm:ss') }}</strong>
                                </a-tooltip>
                                <br />
                                <a-tooltip>
                                    <template slot="title">
                                    Durasi
                                    </template>
                                    ({{ parseInt(momentCustom.duration(moment(record.actual_exam_time_end).diff(moment(record.actual_exam_time_start))).asMinutes()).toFixed(0) }} Menit)
                                </a-tooltip>
                            </template>
                            <template v-else>
                                <a-icon type="calendar" />
                                <strong> {{ moment(record.exam_time_start).format('DD MMMM YYYY') }} </strong> <br/>
                                <a-icon type="schedule" />
                                {{ moment(record.exam_time_start).format('HH:mm:ss') }} - {{ moment(record.exam_time_start).add(record.exam_duration, 'minutes').format('HH:mm:ss') }}
                                <br />
                                <a-tooltip>
                                    <template slot="title">
                                    Durasi
                                    </template>
                                    ({{ record.exam_duration }} Menit)
                                </a-tooltip>
                            </template>
                        </template>
                        <template v-else>
                            <a-tag>
                                Tidak ada ujian
                            </a-tag>
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="status" title="Status" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div style="text-align: center">
                            <a-tag color="red" v-if="record.attendant_exam_status.code == 'NOT_DONE'">
                                {{ record.attendant_exam_status.text }}
                            </a-tag>
                            <a-tag color="red" v-if="record.attendant_exam_status.code == 'NOT_STARTED'">
                               {{ record.attendant_exam_status.text }}
                            </a-tag>
                            <a-tag color="blue" v-else-if="record.attendant_exam_status.code == 'ONGOING'">
                                {{ record.attendant_exam_status.text }}
                            </a-tag>
                            <a-tag v-else-if="record.attendant_exam_status.code == 'CANNOT_START'">
                                {{ record.attendant_exam_status.text }}
                            </a-tag>
                            <div v-else-if="record.attendant_exam_status.code == 'COMPLETED'">
                                <a-tag color="green">
                                    {{ record.attendant_exam_status.text }}
                                </a-tag><br/>
                                Selesai pada: {{ moment(record.attempts[0].ended_at).format('DD MMM YYYY HH:mm:ss') }}
                            </div>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div v-if="(record.exam_status.code == 'ONGOING' && record.actual_exam_time_end == null) || record.attendant_exam_status.code == 'COMPLETED'">
                            <a-button type="primary" size="small" :disabled="record.actual_exam_time_end != null || record.attendant_exam_status.code == 'COMPLETED' ? true: false" @click="questions(record, 1)" block>
                                Kerjakan Ujian <a-icon type="login" />
                            </a-button>
                        </div>
                        <div v-else-if="(record.pretest_status.code == 'ONGOING' && record.actual_pretest_time_end == null)|| record.attendant_pretest_status.code == 'COMPLETED'">
                            <a-button type="primary" size="small" :disabled="record.actual_pretest_time_end != null || record.attendant_pretest_status.code == 'COMPLETED' ? true: false" @click="questions(record, 99)" block>
                                Kerjakan Pretest <a-icon type="login" />
                            </a-button>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="remid" title="Jadwal Remedi" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div v-if="record.attempts.length > 0 && record.attempts[0].is_remid == true">
                            <template v-if="record.remid_time_start != null">
                                <template v-if="record.actual_remid_time_end != null">
                                    <a-tooltip>
                                        <template slot="title">
                                        Remedi dimulai
                                        </template>
                                        <a-icon type="calendar" />
                                        <strong> {{ moment(record.actual_remid_time_start).format('DD MMMM YYYY HH:mm:ss') }} </strong>
                                    </a-tooltip>
                                    <br />
                                    s/d
                                    <br />
                                    <a-tooltip>
                                        <template slot="title">
                                        Remedi berakhir
                                        </template>
                                        <a-icon type="calendar" /><strong> {{ moment(record.actual_remid_time_end).format('DD MMMM YYYY HH:mm:ss') }}</strong>
                                    </a-tooltip>
                                    <br />
                                    <a-tooltip>
                                        <template slot="title">
                                        Durasi
                                        </template>
                                        ({{ parseInt(momentCustom.duration(moment(record.actual_remid_time_end).diff(moment(record.actual_remid_time_start))).asMinutes()).toFixed(0) }} Menit)
                                    </a-tooltip>
                                </template>
                                <template v-else>
                                    <a-icon type="calendar" />
                                    <strong> {{ moment(record.remid_time_start).format('DD MMMM YYYY') }} </strong> <br/>
                                    <a-icon type="schedule" />
                                    {{ moment(record.remid_time_start).format('HH:mm:ss') }} - {{ moment(record.remid_time_start).add(record.exam_duration, 'minutes').format('HH:mm:ss') }}
                                    <br />
                                    <a-tooltip>
                                        <template slot="title">
                                        Durasi
                                        </template>
                                        ({{ record.exam_duration }} Menit)
                                    </a-tooltip>
                                </template>
                            </template>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="status_remid" title="Status Remedi" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div v-if="record.attempts.length > 0 && record.attempts[0].is_remid == true">
                            <div style="text-align: center">
                                <a-tag color="red" v-if="record.attendant_remid_status.code == 'NOT_DONE'">
                                    {{ record.attendant_remid_status.text }}
                                </a-tag>
                                <a-tag color="red" v-if="record.attendant_remid_status.code == 'NOT_STARTED'">
                                {{ record.attendant_remid_status.text }}
                                </a-tag>
                                <a-tag color="blue" v-else-if="record.attendant_remid_status.code == 'ONGOING'">
                                    {{ record.attendant_remid_status.text }}
                                </a-tag>
                                <a-tag v-else-if="record.attendant_remid_status.code == 'CANNOT_START'">
                                    {{ record.attendant_remid_status.text }}
                                </a-tag>
                                <div v-else-if="record.attendant_remid_status.code == 'COMPLETED'">
                                    <a-tag color="green">
                                        {{ record.attendant_remid_status.text }}
                                    </a-tag><br/>
                                    Selesai pada: {{ moment(record.attempts[1].ended_at).format('DD MMM YYYY HH:mm:ss') }}
                                </div>
                            </div>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="action_remid" title="Action Remedi" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div v-if="record.attempts.length > 0 && record.attempts[0].is_remid == true">
                            <div v-if="(record.remid_status.code == 'ONGOING' && record.actual_remid_time_end == null) || record.attendant_remid_status.code == 'COMPLETED'">
                                <a-button type="primary" size="small"
                                            :disabled="record.actual_remid_time_end != null || record.attendant_remid_status.code == 'COMPLETED' ? true: false"
                                            @click="questions(record, 2)"
                                            block>
                                    Kerjakan Remedi <a-icon type="login" />
                                </a-button>
                            </div>
                        </div>
                    </template>
                </a-table-column>

            </a-table>
        </a-card>
    </div>
</template>

<script>
import momentCustom from 'moment'

export default {
    created() {
        this.getItems();
    },
    data() {
        return {
            momentCustom,
            form: this.$form.createForm(this),
            loading: false,
            visible: false,
            items: {},
            data: []
        };
    },
    methods: {
        examColor(code){
            switch(code){
                case 'NOT_STARTED':
                    return 'red'
                case 'ONGOING':
                    return 'blue'
                case 'COMPLETED':
                    return 'green'
            }
        },
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.classical-exam-session"))
                .then(response => {
                    this.items = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        questions(record, attempt){
            let params = {
                attempt_number: attempt,
                session: record.id
            }

            window.location.href = this.routeUri('admin.classical.attendant.exam.questions') + '?' + this.$qs.stringify(params)
        },
    },
};
</script>
